(function () {
  'use strict';

  /**
   * Country-Gate: Lieferland-Auswahl.
   * ------------------------------------------------------------------
   * Wahrheit fuer "geblockt oder nicht" ist die Markt-Zuordnung von
   * Shopify (localization.country, hier cfg.marketCountry): Liquid
   * rendert die Klasse country-gate--blocked bereits im <html>-Tag,
   * wenn das Lokalisierungs-Land in country_gate_blocked liegt — also
   * auch beim Erstbesuch ohne Klick (Shopify-Geo-IP ordnet CH-Besucher
   * dem Markt Schweiz zu).
   *
   * Dieses Script haelt Besucher-Wahl und Shopify-Lokalisierung synchron:
   * - Erstbesuch (keine gespeicherte Wahl): Top-Banner einblenden,
   *   Vorschlag = Shopify-Marktland (Fallback navigator.language).
   * - Auswahl: localStorage + Cookie-Spiegel (1 Jahr). Weicht die Wahl
   *   vom Shopify-Marktland ab, wird das Lokalisierungs-Formular von
   *   Shopify (POST /localization) abgeschickt — die Seite laedt im
   *   gewaehlten Markt neu (Waehrung + Gate-Klasse serverseitig korrekt).
   * - Permanenter Umschalter (announcement-bar): zeigt aktuelle Wahl,
   *   Klick oeffnet den Banner erneut.
   * Rein visuelles Gate (GF-akzeptiert): blockt keine Requests, aendert
   * keine Preise — CSS blendet Preis-/Kauf-Flaechen aus.
   * Konfiguration kommt aus theme.countryGate (layout/theme.liquid).
   */

  var cfg = window.theme && window.theme.countryGate;
  if (!cfg) return;

  var COOKIE = cfg.cookieName || 'apx_delivery_country';
  var SYNC_KEY = COOKIE + '_sync';
  var BLOCKED_CLASS = 'country-gate--blocked';
  var YEAR_SECONDS = 365 * 24 * 60 * 60;

  function normList(value) {
    return String(value || '').split(',').map(function (s) {
      return s.trim().toUpperCase();
    }).filter(Boolean);
  }

  var countries = normList(cfg.countries);
  var blocked = normList(cfg.blocked);
  var marketCountry = String(cfg.marketCountry || '').toUpperCase();

  function isBlocked(code) {
    return blocked.indexOf(code) !== -1;
  }

  // ISO-Code -> Flaggen-Emoji (Regional Indicator Symbols), generisch fuer jeden 2-Letter-Code.
  function flagEmoji(code) {
    if (!/^[A-Z]{2}$/.test(code) || !String.fromCodePoint) return '';
    return String.fromCodePoint(0x1f1e6 + code.charCodeAt(0) - 65, 0x1f1e6 + code.charCodeAt(1) - 65);
  }

  function readCookie() {
    var m = document.cookie.match(/(?:^|;\s*)apx_delivery_country=([A-Za-z]{2})/);
    return m ? m[1].toUpperCase() : null;
  }

  function getChoice() {
    var v = null;
    try { v = window.localStorage.getItem(COOKIE); } catch (e) { /* Safari private mode */ }
    return (v && /^[A-Za-z]{2}$/.test(v)) ? v.toUpperCase() : readCookie();
  }

  function setChoice(code) {
    try { window.localStorage.setItem(COOKIE, code); } catch (e) { /* egal, Cookie reicht */ }
    document.cookie = COOKIE + '=' + code + '; max-age=' + YEAR_SECONDS + '; path=/; SameSite=Lax';
    apply(code);
  }

  // Gate-Klasse: geblockt, wenn die Wahl ODER das Shopify-Marktland geblockt ist.
  // Das Marktland gewinnt immer — ein Klick auf "DE" kann einen CH-Markt nicht freischalten,
  // erst der Lokalisierungs-Sync (Reload im DE-Markt) nimmt die Klasse serverseitig weg.
  function apply(code) {
    document.documentElement.classList.toggle(BLOCKED_CLASS, isBlocked(code) || isBlocked(marketCountry));
    updateSwitcher(code);
  }

  // Shopify-Lokalisierung auf die Wahl nachziehen (Markt + Waehrung). Einmal pro Session und
  // Land versuchen — verhindert eine Reload-Schleife, falls Shopify das Land nicht uebernimmt.
  function syncLocalization(code) {
    if (!code || code === marketCountry || countries.indexOf(code) === -1) return false;
    try {
      if (window.sessionStorage.getItem(SYNC_KEY) === code) return false;
      window.sessionStorage.setItem(SYNC_KEY, code);
    } catch (e) { /* ohne sessionStorage trotzdem einmal versuchen */ }

    var form = document.createElement('form');
    form.method = 'post';
    form.action = cfg.localizationUrl || '/localization';
    form.hidden = true;
    var fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'put',
      country_code: code,
      return_to: window.location.pathname + window.location.search
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return true;
  }

  // Vorschlag: Shopify-Marktland (Geo-IP), sonst Browser-Sprache (de-CH -> CH); nur wenn waehlbar.
  function suggestedCountry() {
    if (marketCountry && countries.indexOf(marketCountry) !== -1) return marketCountry;
    var lang = (navigator.languages && navigator.languages[0]) || navigator.language || '';
    var m = String(lang).match(/-([A-Za-z]{2})\b/);
    var region = m ? m[1].toUpperCase() : null;
    return (region && countries.indexOf(region) !== -1) ? region : null;
  }

  function updateSwitcher(code) {
    var switchers = document.querySelectorAll('[data-country-gate-switcher]');
    for (var i = 0; i < switchers.length; i++) {
      var current = switchers[i].querySelector('[data-country-gate-current]');
      if (current) current.textContent = flagEmoji(code) + ' ' + code;
      switchers[i].hidden = !code;
    }
  }

  function init() {
    var banner = document.querySelector('[data-country-gate-banner]');
    if (!banner) return;

    // Flaggen-Emoji in die Options-Buttons rendern.
    var flags = banner.querySelectorAll('[data-country-flag]');
    for (var i = 0; i < flags.length; i++) {
      flags[i].textContent = flagEmoji(flags[i].getAttribute('data-country-flag'));
    }

    var choice = getChoice();
    if (choice) {
      // localStorage kann eine Wahl haben, deren Cookie abgelaufen ist -> Cookie auffrischen.
      setChoice(choice);
      // Altzustand oder Marktwechsel durch Shopify: Lokalisierung auf die Wahl nachziehen.
      if (syncLocalization(choice)) return;
    } else {
      banner.hidden = false;
      var suggestion = suggestedCountry();
      if (suggestion) {
        var btn = banner.querySelector('.js-country-gate-select[data-country="' + suggestion + '"]');
        if (btn) btn.classList.add('country-gate-banner__option--suggested');
      }
    }

    banner.addEventListener('click', function (evt) {
      var btn = evt.target.closest ? evt.target.closest('.js-country-gate-select') : null;
      if (!btn) return;
      var code = btn.getAttribute('data-country');
      banner.hidden = true;
      setChoice(code);
      syncLocalization(code);
    });

    // Permanenter Umschalter: Banner wieder oeffnen.
    document.addEventListener('click', function (evt) {
      var sw = evt.target.closest ? evt.target.closest('[data-country-gate-switcher]') : null;
      if (!sw) return;
      banner.hidden = false;
      if (banner.scrollIntoView) banner.scrollIntoView({ block: 'nearest' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
